import { Select, Box, MenuItem } from '@mui/material';
interface SelectFieldComponentProps {
  onChange: (event: any) => void;
  label: string;
  keyName: string;
  name: string;
  isRequired: boolean;
  value: string;
  errorStr: string;
  disabled?: boolean;
  items: any[];
  onBlur?: (event: any) => void;
  isHidden?: boolean;
}
const SelectFieldComponent: React.FC<SelectFieldComponentProps> = ({
  onChange,
  label,
  isRequired,
  value,
  keyName,
  name,
  errorStr,
  disabled,
  items,
  onBlur,
  isHidden,
}) => {
  return (
    <Box
      sx={{ mb: 3, display: isHidden ? 'none' : 'block' }}
      key={'ele_' + keyName}
    >
      <Box sx={{ mb: 1 }} className="form-label" key={'lbl_' + keyName}>
        {label}
        {isRequired && (
          <small style={{ color: 'red' }} key={'sm_' + keyName}>
            {' '}
            *
          </small>
        )}
      </Box>
      <Select
        className="form-select"
        id={keyName}
        key={keyName}
        name={name}
        value={value}
        disabled={disabled}
        onChange={(e: any) => {
          onChange(e);
        }}
        onBlur={onBlur}
        fullWidth
      >
        {items.map((item, index) => (
          <MenuItem
            key={keyName + '_' + index}
            value={item.id}
            sx={{ minHeight: '35px !important' }}
          >
            {item.label ? item.label : item.name ? item.name : item.id}
          </MenuItem>
        ))}
      </Select>
      {errorStr && <span className="bad-field">{errorStr}</span>}
    </Box>
  );
};
export default SelectFieldComponent;
